import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const QRTitle = styled.h2`
  text-align: center;
`;
export const ButtonQR = styled.button`
  width: 10%;
  padding: 20px;
  border-radius: 8px;
  .botonQr-text {
    color: white;
  }
  @media (max-width: 768px) {
    width: 40%;
  }
`;
